import React, { useState, forwardRef, useImperativeHandle } from 'react';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';


const ExitDetails = forwardRef((props, ref) => {
     // Add validation support
     const [validationErrors, setValidationErrors] = useState({});

     useImperativeHandle(ref, () => ({
          validateForm: () => {
               return true;
          },
          clearValidation: () => {
               setValidationErrors({});
          }
     }));
     const [localFormData, localSetFormData] = useState({
          resignation: '',
          resignation_date: '',
          relieving_date: '',
          last_working_date: '',
          last_pay_date: '',
          separation_status: '',
          notice_period: '',
     });
     const formData = props.formData !== undefined ? props.formData : localFormData;
     const setFormData = props.setFormData !== undefined ? props.setFormData : localSetFormData;

     return (
          <div className="custom_form_wrapper">
               <div className="form-grid">
                    <div className="form-floating">
                         <select
                              className="form-select"
                              name="resignation"
                              id="resignation"
                              value={formData.resignation || 'No'}
                              onChange={e => setFormData({ ...formData, resignation: e.target.value })}
                         >
                              <option value="No">No</option>
                              <option value="Yes">Yes</option>
                         </select>
                         <label htmlFor="resignation">Resignation</label>
                    </div>
                    <div className="form-floating">
                         <input
                              type="text"
                              className="form-control form-control-sm"
                              name="resignation_date"
                              id="resignation_date"
                              placeholder=" "
                              value={formData.resignation_date || ''}
                              onChange={e => setFormData({ ...formData, resignation_date: e.target.value })}
                              onFocus={e => e.target.type = 'date'}
                              onBlur={e => { if (!e.target.value) e.target.type = 'text'; }}
                              max={new Date().toISOString().split('T')[0]}
                              autoComplete="off"
                         />
                         <label htmlFor="resignation_date">Resignation Date</label>
                    </div>
                    <div className="form-floating">
                         <input
                              type="text"
                              className="form-control form-control-sm"
                              name="relieving_date"
                              id="relieving_date"
                              placeholder=" "
                              value={formData.relieving_date || ''}
                              onChange={e => setFormData({ ...formData, relieving_date: e.target.value })}
                              onFocus={e => e.target.type = 'date'}
                              onBlur={e => { if (!e.target.value) e.target.type = 'text'; }}
                              max={new Date().toISOString().split('T')[0]}
                              autoComplete="off"
                         />
                         <label htmlFor="relieving_date">Relieving Date</label>
                    </div>
                    <div className="form-floating">
                         <input
                              type="text"
                              className="form-control form-control-sm"
                              name="last_working_date"
                              id="last_working_date"
                              placeholder=" "
                              value={formData.last_working_date || ''}
                              onChange={e => setFormData({ ...formData, last_working_date: e.target.value })}
                              onFocus={e => e.target.type = 'date'}
                              onBlur={e => { if (!e.target.value) e.target.type = 'text'; }}
                              max={new Date().toISOString().split('T')[0]}
                              autoComplete="off"
                         />
                         <label htmlFor="last_working_date">Last Working Date</label>
                    </div>
                    <div className="form-floating">
                         <input
                              type="text"
                              className="form-control form-control-sm"
                              name="last_pay_date"
                              id="last_pay_date"
                              placeholder=" "
                              value={formData.last_pay_date || ''}
                              onChange={e => setFormData({ ...formData, last_pay_date: e.target.value })}
                              onFocus={e => e.target.type = 'date'}
                              onBlur={e => { if (!e.target.value) e.target.type = 'text'; }}
                              max={new Date().toISOString().split('T')[0]}
                              autoComplete="off"
                         />
                         <label htmlFor="last_pay_date">Last Pay Date</label>
                    </div>
                    <div className="form-floating">
                         <select
                              className="form-select"
                              name="separation_status"
                              id="separation_status"
                              value={formData.separation_status}
                              onChange={e => setFormData({ ...formData, separation_status: e.target.value })}
                         >
                              <option value="" disabled hidden>Separation Status</option>
                              <option value="Resigned">Resigned</option>
                              <option value="Terminated">Terminated</option>
                              <option value="Retired">Retired</option>
                              <option value="Absconded">Absconded</option>
                         </select>
                         <label htmlFor="separation_status" style={{ opacity: formData.separation_status ? 1 : 0 }}>Separation Status</label>
                    </div>
                    <div className="form-floating">
                         <input
                              type="text"
                              className="form-control form-control-sm"
                              name="notice_period"
                              id="notice_period"
                              placeholder=" "
                              value={formData.notice_period}
                              onChange={e => setFormData({ ...formData, notice_period: e.target.value })}
                              autoComplete="off"
                         />
                         <label htmlFor="notice_period">Notice Period</label>
                    </div>
               </div>
          </div>
     );
});

export default ExitDetails;